import { combineReducers } from 'redux'
import { UPDATE_HEALTH_CHECKLIST, UPDATE_FINANCIAL_CHECKLIST } from './actions'

export const healthCheckList = (state = [], action) => {
  switch (action.type) {
    case UPDATE_HEALTH_CHECKLIST:
      return action.payload
    default:
      return state
  }
}

export const financialCheckList = (state = [], action) => {
  switch (action.type) {
    case UPDATE_FINANCIAL_CHECKLIST:
      return action.payload
    default:
      return state
  }
}

export const reducer = combineReducers({
  healthCheckList,
  financialCheckList,
})
